import { Injectable } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { NoteService } from '../../services/note/note.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';

@Injectable()
export class FileService {

	constructor(
		private dataService: DataService,
		private noteService: NoteService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private commsService: CommsService
	) { }

	deleteFile(id) {
		const self = this;
		this.displayService.addLoaderId(id);
		this.commsService.removeFile(id).subscribe((res) => {
			this.displayService.removeLoaderId(id);
			const jsonRes = res;
			console.log('DELETE DOC RES: ', jsonRes);
			this.dataService.boadcastFileDelete();
		}, (err) => {
			this.displayService.endLoading();
			this.displayService.removeLoaderId(id);
			if (err && err.error && err.error.message) {
					self.noteService.displayError(err.error.message);
			}
		});
	}

	openFile(id, name) {
		this.commsService.loadFile(id).subscribe((res) => {
			console.log('OPEN DOC SUCCESS', res);
			if (res) {
				const blob = new Blob([res], { type: 'arraybuffer' });
				this.commsService.saveBlob(blob, name);
			}
		}, (err) => {
			this.commsService.handleAPIError('Load document', err);
		});
	}


}
